export default __webpack_public_path__ + "static/media/run-error.cbdfa7b8.svg";